export const getTimerBackgroundColor = (currentSeconds: number, isActive: boolean) => {
  if (currentSeconds < 300) {
    return 'error.main';
  }
  if (isActive) {
    return 'primary.main';
  }
  return 'rgba(25, 25, 25, 0.90)';
};
